import { createContext, useContext } from "react";
import type { useTooltip } from "./useTooltip";

export const TooltipContext = createContext<ReturnType<
  typeof useTooltip
> | null>(null);

export const useTooltipContext = () => {
  const context = useContext(TooltipContext);
  if (!context) throw new Error("Tooltip must be used within TooltipContainer");
  return context;
};
